import { FilledButton, OutlinedButton } from '@/components/UI/Button';
import { Box, styled, Typography } from '@mui/material';

import { StatusChip } from '../styles';

export const HeaderContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '24px',
  marginTop: '8px',
}));

export const TitleContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
}));

export const PageTitle = styled(Typography)(() => ({
  color: '#1A1A1A',
  fontSize: '24px',
  fontWeight: 600,
  lineHeight: '140%',
}));

export const DetailStatusChip = styled(StatusChip)(() => ({
  textTransform: 'lowercase',
}));

export const ToggleContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginTop: '16px',
  color: '#1A1A1A',
  fontSize: '14px',
  fontWeight: 600,
}));

export const ActionsContainer = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
}));

export const PreviewButton = styled(FilledButton)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  width: 'fit-content',
  height: '40px',
  padding: '10px 24px',
  display: 'flex',
  gap: '8px',

  '& span': {
    fontSize: '20px',
  },

  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));

export const EditButton = styled(OutlinedButton)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  width: 'fit-content',
  height: '40px',
  padding: '10px 24px',
  display: 'flex',
  gap: '8px',

  '& span': {
    fontSize: '20px',
  },

  '&:hover': {
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    filter: 'brightness(85%)',
  },
}));

export const DeleteButton = styled(FilledButton)(({ theme }) => ({
  backgroundColor: '#E31B0C',
  color: theme.palette.common.white,
  width: 'fit-content',
  height: '40px',
  borderRadius: '8px',
  padding: '10px 24px',
  display: 'flex',
  gap: '8px',

  '& span': {
    fontSize: '20px',
  },

  '&:hover': {
    backgroundColor: '#E31B0C',
    filter: 'brightness(85%)',
  },
}));

export const InfoBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '48px',
  backgroundColor: theme.palette.common.white,
  border: '1px solid #EAECF0',
  borderRadius: '8px',
  padding: '12px 24px',
  marginTop: '24px',
  color: '#475467',
  fontSize: '14px',

  '& strong': {
    color: '#1A1A1A',
  },
}));

export const MetricsContainer = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
  gap: '24px',
  marginTop: '24px',
}));

export const MetricCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  border: '1px solid #EAECF0',
  borderRadius: '8px',
  padding: '20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
}));

export const MetricHeader = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const MetricIcon = styled(Box)<{ color: string; background: string }>(
  ({ color, background }) => ({
    width: '36px',
    height: '36px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: background,
    color,

    '& span': {
      fontSize: '20px',
    },
  })
);

export const MetricBadge = styled('span')(() => ({
  backgroundColor: '#F2F4F7',
  color: '#475467',
  borderRadius: '12px',
  padding: '2px 10px',
  fontSize: '12px',
  fontWeight: 600,
}));

export const MetricValue = styled(Typography)(() => ({
  color: '#1A1A1A',
  fontSize: '24px',
  fontWeight: 600,
  lineHeight: '120%',
}));

export const MetricLabel = styled(Typography)(() => ({
  color: '#475467',
  fontSize: '13px',
  lineHeight: '140%',
}));

export const NoteText = styled(Typography)(() => ({
  color: '#475467',
  fontSize: '13px',
  lineHeight: '150%',
  marginTop: '24px',

  '& strong': {
    color: '#1A1A1A',
  },
}));
